import Card from "../components/Card/Card";
import { Helmet } from "react-helmet";
import sendRequest from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
// import pics
import order from "../assets/images/2799166.png";
import repair from "../assets/images/1698478.png";
import sale from "../assets/images/3211590.png";

import { useEffect, useState } from "react";
import UpdateOrderModal from "common/order/UpdateOrderModal";
import UpdateRepairModal from "common/order/UpdateRepairModal";
import ComplatePriceModalAdmin from "common/order/ComplatePriceModalAdmin";
import Pagination from "rc-pagination";
import { ProductsOrder } from "common/order/ProductsOrder";
import { ProductsRepair } from "common/order/ProductsRepair";
import StatusReportModal from "common/order/StatusReportModal";
import axios from "axios";

function AdminDashboard() {
  const [adminInfo, setAdminInfo] = useState({});
  const [orderLists, setOrderLists] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [updateList, setUpdateList] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [chatList, setChatList] = useState([]);
  const updateSelectedItem = (information) => {
    setSelectedItem(information);
    setChatList(information.chats);
  };
  useEffect(() => {
    axios
      .post(`http://oilb.tatdemo.ir/adminarea/orders_info`)
      .then(({ data }) => {
        setAdminInfo(data);
      });
  }, []);
  // state info from api

  useEffect(() => {
    axios
      .post(`http://oilb.tatdemo.ir/adminarea/orders_being_processed`)
      .then(({ data }) => {
        setOrderLists(data.info);
      });
  }, [updateList]);
  // console.log("ord", orderLists);
  // console.log("orderLisst", orderLists);
  return (
    <div className="d-flex flex-wrap m-2">
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`داشبورد ادمين`} </title>
          <link rel="canonical" href="http://mysite.com/example" />
        </Helmet>
      </div>
      <>
        <UpdateRepairModal selectedItem={selectedItem}></UpdateRepairModal>
        <ComplatePriceModalAdmin selectedItem={selectedItem} />
        <UpdateOrderModal
          selectedItem={selectedItem}
          updateSelectedItem={updateSelectedItem}
        ></UpdateOrderModal>
        <StatusReportModal
          selectedItem={selectedItem}
          pageType="0"
          // chats={selectedItem.chats}
          // chats={chatList}
          // setChats={setChatList}
        ></StatusReportModal>

        <div className="col-md-4 col-6">
          <Card
            title="تعداد کل سفارشات"
            lightColor="#F2CC5B"
            darkColor="#B89B45"
            number={adminInfo.all_orders_count}
            imgSrc={order}
            underline={true}
          ></Card>
        </div>
        <div className="col-md-4 col-6">
          <Card
            title="سفارشات در حال پردازش"
            lightColor="#503E9D"
            darkColor="#281F4F"
            number={adminInfo.orders_being_processed_count}
            imgSrc={repair}
            underline={true}
          ></Card>
        </div>
        <div className="col-md-4 col-6">
          <Card
            title="تعداد سفارشات بدهکار"
            lightColor="#56A689"
            darkColor="#3E7763"
            number={adminInfo.orders_owed_count}
            imgSrc={sale}
            underline={true}
          ></Card>
        </div>
      </>
      <div className="order-container">
        {[...orderLists]
          ?.reverse()
          ?.slice((currentPage - 1) * 5, (currentPage - 1) * 5 + 5)
          ?.map((value, index) => {
            if (value.type == "0") {
              return (
                <ProductsOrder
                  data={value}
                  index={index}
                  updateSelectedItem={updateSelectedItem}
                  pageType="admin"
                  setUpdaterList={setUpdateList}
                ></ProductsOrder>
              );
            } else {
              return (
                <ProductsRepair
                  data2={value}
                  index={index}
                  updateSelectedItem={updateSelectedItem}
                  pageType="admin"
                ></ProductsRepair>
              );
            }
          })}
        <div className="d-flex justify-content-center mt-4">
          <div>
            <Pagination
              total={orderLists.length}
              pageSize={5}
              current={currentPage}
              onChange={(newPage) => {
                setCurrentPage(newPage);
              }}
            ></Pagination>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
